<template>
  <div class="main">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>推荐岗位管理</el-breadcrumb-item>
      <el-breadcrumb-item>发布岗位</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="xcx">
      <div>小程序发布岗位</div>
      <img src="../../../assets/img/qxiaoyunxcx.jpg" alt />
    </div>
    <el-row style="margin-top: 30px;">
      <el-button type="primary" @click="pushRouter('/add-job-to-sign?operate=add')">发布推荐岗位</el-button>
      <span class="info2">该岗位为平台效果最快，投递量最大的岗位发布方式，付费后平台直接推送给每天登陆的数十万学生，高曝光率，一天即可收到数十份简历！</span>
    </el-row>
    <el-table style="width: 100%; margin-top: 20px;" :data="tableData">
      <el-table-column label="发布时间" show-overflow-tooltip prop="created_at"></el-table-column>
      <el-table-column label="岗位名称" show-overflow-tooltip prop="job_name"></el-table-column>
      <el-table-column label="招聘人数" show-overflow-tooltip prop="recruitment"></el-table-column>
      <el-table-column label="薪资待遇" show-overflow-tooltip prop="salayStr"></el-table-column>
      <el-table-column label="食宿安排" show-overflow-tooltip prop="food_bed_str"></el-table-column>
      <el-table-column label="学历要求" show-overflow-tooltip prop="edu"></el-table-column>
      <el-table-column label="工作地点" show-overflow-tooltip prop="job_address"></el-table-column>
      <!-- <el-table-column label="付费状态" show-overflow-tooltip prop="pay"></el-table-column> -->
      <el-table-column label="操作" width="200px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="check(scope.row)">查看</el-button>
          <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
          <!-- <el-button size="mini" type="primary" :disabled="scope.row.pay_status === 'paid'" @click="pay(scope.row.id)">付费</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="detailDialogVisible" width="500px" :append-to-body="true">
      <el-row v-for="item in jobDetail" :key="item.prop">
        <el-col :span="6">
          <div style="text-align: right;">{{ item.label }}</div>
        </el-col>
        <el-col :span="12">
          <div v-if="item.prop=='job_detail'" v-html="item.value" style="white-space: pre-wrap;"></div>
          <div v-else>{{item.value}}</div>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- <v-add-edit
      :visible="addEditVisible"
      operate="edit"
      :form="row"
      @closeAddEdit="close"
      @refresh="getTableData"
    ></v-add-edit>-->
  </div>
</template>

<script>
import formatter from "@/assets/js/mixins/formatter";
import PaymentTipDialog from "@/components/PaymentTipDialog";
// import addEdit from "./components/add-edit";
import baseUrl from "@/api/baseUrl.js";
import axios from "axios";
import qs from "qs";

export default {
  components: {
    "v-payment": PaymentTipDialog
    // "v-add-edit": addEdit
  },
  mixins: [formatter],
  data() {
    return {
      tableData: [],
      detailDialogVisible: false, // 详情对话框是否显示
      addEditVisible: false, // 更新对话框是否显示
      jobDetail: [
        // 岗位详情
        { label: "职位名称：", prop: "job_name", value: "" },
        // { label: "职位类型：", prop: "job_type", value: "" },
        { label: "薪资待遇：", prop: "salary", value: "" },
        { label: "招聘人数：", prop: "recruitment", value: "" },
        { label: "食宿安排：", prop: "food_bed_str", value: "" },
        { label: "学历要求：", prop: "edu", value: "" },
        // { label: "年龄要求：", prop: "age_require", value: "" },
        { label: "工作城市：", prop: "city", value: "" },
        { label: "详细地址：", prop: "job_address", value: "" },
        { label: "职位描述：", prop: "job_detail", value: "" },
        // { label: "截至时间：", prop: "end_time", value: "" },
        { label: "付费状态：", prop: "pay", value: "" }
      ],
      row: {}
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    async getTableData() {
      let res = await this.$api.job.getSignJobs();
      if (res.code === 0 && res.data) {
        this.tableData = res.data.map(item => {
          item.food_bed_str = this.formatFood(item.food_bed);
          item.edu = this.formatEdu(item.education_require);
          item.pay = this.formatPay(item.pay_status);
          item.salayStr = this.formatSalary(item.salary);
          return item;
        });
      }
    },
    formatFood(id) {
      let val = ''
      this.$store.state.foodBedList.forEach(item => {
        if (id == item.code) {
          val = item.value
        } 
      })
      return val
    },
    formatEdu(id) {
      console.log(id)
      let val = ''
      let arr = [
        {label: '中专', value: '1'},
        {label: '大专', value: '2'},
        {label: '本科', value: '3'},
        {label: '研究生', value: '4'},
      ]
      arr.forEach(item => {
        if (item.value == id) {
          val = item.label
        }
      })
      console.log(val)
      return val
    },
    async check(row) {
      if (row.province_id) {
        row.city = this.formatProv(row.province_id);
        if (row.city_id) {
          let res = await this.$api.common.getXixunCity(row.province_id);
          row.city += this.formatCity(res.data, row.city_id);
        }
      }

      this.jobDetail.forEach(item => {
        item.value = row[item.prop];
      });
      this.detailDialogVisible = true;
    },
    edit(row) {
      localStorage.setItem("job", JSON.stringify(row));
      this.$router.push({
        path: "/add-job-to-sign",
        query: {
          operate: "update"
        }
      });
    },
    close() {
      this.addEditVisible = false;
    },
    pay(id) {
      let params = {
        sign_job_id: id,
        subject: "万博云智招聘服务费",
        type: "web"
      };
      axios
        .post(
          `${baseUrl}api/enterprise/pay/signJob/alipay/index`,
          qs.stringify(params),
          { withCredentials: true }
        )
        .then(res => {
          const div = document.createElement("div");
          div.innerHTML = res.data;
          document.body.appendChild(div);
          document.forms[0].acceptCharset = "GBK";
          document.forms["alipay_submit"].submit();
        });
    }
  }
};
</script>

<style>
.main {
  position: relative;
  padding: 20px 0 0 20px;
}
.info2 {
  color: red;
  margin-left: 15px;
  font-size: 14px;
}
</style>
<style lang="scss" scoped>
.xcx {
  position: absolute;
  top: 5px;
  right: 50px;
  text-align: center;
  font-size: 12px;
  color: red;
  font-weight: bold;
  img {
    width: 100px;
  }
}
</style>